import type { AgendaWindow } from './next-run';

export const AGENDA_CHANNEL_FILTERS = [
  { value: 'all', label: 'Todos os canais' },
  { value: 'push', label: 'Push' },
  { value: 'email', label: 'E-mail' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'sms', label: 'SMS' },
] as const;

export const AGENDA_FREQ_FILTERS = [
  { value: 'all', label: 'Todas as frequências' },
  { value: '1', label: 'Diário' },
  { value: '7', label: 'Semanal' },
  { value: '30', label: 'Mensal' },
  { value: '31', label: 'Único' },
] as const;

export const AGENDA_WINDOW_FILTERS: ReadonlyArray<{ value: AgendaWindow; label: string }> = [
  { value: 'today', label: 'Hoje' },
  { value: '7d', label: 'Próximos 7 dias' },
  { value: 'all', label: 'Todas' },
];
